
import React from 'react';

import { PrivacyLink, TermsOfServiceLink } from 'pages/checkout/components/common/ExternalLinks';
import { TermsDisclaimer } from 'pages/checkout/components/common/typographic-styled-components';

export const SmsPromoDisclaimer = ({ includeMsgFrequencyCopy = true }: { includeMsgFrequencyCopy?: boolean; }) => {
  return (
    <TermsDisclaimer>
      By continuing, you agree to receive text messages from Opencare, and agree to
      our <TermsOfServiceLink /> and <PrivacyLink />.
      {includeMsgFrequencyCopy
      && (
        <>
          {' '}Msg frequency varies.
          Msg & data rates may apply.
        </>
      )}
    </TermsDisclaimer>
  );
};
